import { SeasonEnum } from '../../../../../../../../lib/graphql'

export const getLabelLineSeasonPrice = (season: SeasonEnum) => {
  switch (season) {
    case SeasonEnum.LOW:
      return 'basse saison'
    case SeasonEnum.MEDIUM:
      return 'moyenne saison'
    case SeasonEnum.HIGH:
      return 'haute saison'
  }
}
